import React, { useState, useRef } from "react";
import Logo from "../assets/img/NewsImgs/newLogo.webp";
import Person from "../assets/icon/NewsIcons/Login/LoginPerson";
import Lock from "../assets/icon/NewsIcons/Login/LoginLock";
import Eye from "../assets/icon/NewsIcons/Login/LoginEye";
import Reload from "../assets/icon/NewsIcons/Login/LoginReload";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../commons/inFormTypes";
import Cookies from 'universal-cookie';
import ClipLoader from "react-spinners/ClipLoader";
import { Link } from "react-router-dom";
import ClientCaptcha from 'react-client-captcha'

const Login = () => {
    const [user, setUser] = useState();
    const [erUser, setErUser] = useState(false);
    const [pass, setPass] = useState();
    const [erPass, setErPass] = useState(false);
    const [erCaptch, setErCaptch] = useState(false);
    const [captcha, setCaptcha] = useState();
    const [captchaIn, setCaptchaIn] = useState();
    const [isShown, setIsShown] = useState(false);
    const [snipper, setSnipper] = useState(false);
    const [guid, setGuid] = useState();
    let navigate = useNavigate();
    const captchaRef = useRef();
    const [isVisible, setVisible] = useState(false);

    const handleClick = () => {
        setIsShown(!isShown);
    };

    const getDataAsync = async () => {
        axios.post(apiUrl + "Auth/Login", {
            Username: user.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)),
            Password: pass.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)),
            Captcha: captcha
        })
            .then(response => {
                if (response.request.status === 200) {
                    const cookies = new Cookies();
                    cookies.set('token', response.data.token, { path: '/' });
                    cookies.set('name', response.data.name + " " + response.data.family, { path: '/' });
                    cookies.set('role', response.data.role, { path: '/' });
                    setSnipper(false);
                    navigate("/mainadmin/PublishedNewses");
                } else {
                    handleClick();
                    setSnipper(false);
                    captchaRef.current.generateCaptcha()

                }
            })
            .catch(error => {
                console.log(error);
                handleClick();
                setSnipper(false);
                captchaRef.current.generateCaptcha()

            });
    };

    const login = async () => {
        setSnipper(true);
        // console.log(88)
        // console.log( captchaRef.current.captchaCode)
        // console.log(captchaRef.current)

        if (!pass || !user || !captcha || captcha != captchaRef.current.captchaCode) {
            if (!pass) {
                setErPass(true);
                setSnipper(false);
                captchaRef.current.generateCaptcha()

            }
            if (!user) {
                setErUser(true);
                setSnipper(false);
                captchaRef.current.generateCaptcha()

            }
            if (captcha != captchaRef.current.captchaCode) {
                // handleClick();
                setErCaptch(true);

                setSnipper(false);
                captchaRef.current.generateCaptcha()
            }
        } else {
            setErPass(false);
            setErUser(false);
            if (!user || !pass) {
                handleClick();
                setSnipper(false);
                captchaRef.current.generateCaptcha()
            } else {
                await getDataAsync();
            }
        }
    };

    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            login();
        }
    };

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength);
        }
    };

    const toggle = () => {
        setVisible(!isVisible);
    };
    return (
        <div className="bg-backGray h-screen pt-[106px] flex justify-center">
            <div className="w-[399px] min-h-[490px] h-fit bg-white rounded-[25px] shadow-main-shadow py-[28px] px-[46px]">
                <div className="flex justify-center">
                    <img src={Logo} className="w-[30%]"/>
                </div>
                <div className="mt-2">
                    <p className="text-[15px] font-IRANYekanExtra mb-[4px]">نام کاربری</p>
                    <div className="flex h-[40px] justify-start items-center w-full border-[1px] border-borderGray2 rounded-[5px] px-[13px]">
                        <Person />
                        <input
                            className="h-[35px] w-full text-[15px] focus:outline-none mr-[10px] font-IRANYekanMedium"
                            onChange={(e) => {setUser(e.target.value);setErUser(false)}}
                            onKeyDown={handleKeyDown}
                            onInput={maxLengthCheck}
                            maxLength={20}
                            autoComplete="off"
                            type="text"
                        />
                    </div>
                    {
                        erUser ?
                            <span class="flex items-center font-medium font-IRANYekanMedium mt-1 tracking-wide text-[#ff0000] text-xs  ml-1">
                                لطفا نام کاربری را وارد نمایید !
                            </span>
                            :
                            null
                    }
                </div>
                <div className="mt-4">
                    <p className="text-[15px] font-IRANYekanExtra mb-[4px]">رمز عبور</p>
                    <div className="flex h-[40px] justify-start items-center w-full border-[1px] border-borderGray2 rounded-[5px] px-[13px]">
                        <Lock />
                        <input
                            className="h-[35px] w-full text-[15px] focus:outline-none mx-[10px] font-IRANYekanMedium"
                            type={!isVisible ? "password" : "text"} onChange={(e) => {setPass(e.target.value);setErPass(false)}}
                            onKeyDown={handleKeyDown}
                            maxLength={10}
                            onInput={maxLengthCheck}
                            autoComplete="off"
                        />
                        <Eye onClick={toggle} />
                    </div>
                    {
                        erPass ?
                            <span class="flex items-center font-medium font-IRANYekanMedium mt-1 tracking-wide text-[#ff0000] text-xs  ml-1">
                                لطفا پسورد را وارد نمایید !
                            </span>
                            :
                            null
                    }
                </div>
                <div className="flex items-end justify-between">
                    <div className="mt-4 w-[162px]">
                        <p className="text-[15px] font-IRANYekanExtra mb-[4px]">کد امنیتی</p>
                        <div className="flex h-[40px] justify-start items-center w-full border-[1px] border-borderGray2 rounded-[5px] px-[13px]">
                            <Lock />
                            <input
                                onChange={(e) => {setCaptcha(e.target.value);setErCaptch(false)}}
                                maxLength={4}
                                className="h-[35px] w-full text-[15px] focus:outline-none mr-[10px] font-IRANYekanMedium"
                                type="text"
                            />
                        </div>
                    </div>
                    <div className="flex items-center">
                        {/* <div className="rounded-[5px] bg-borderGray2 h-[40px] w-[96px] mr-[5px] ml-[13px] flex justify-center items-center">
                            <p>A8B6!</p>
                        </div> */}
                        {/* <Reload /> */}
                        <ClientCaptcha ref={captchaRef} captchaCode={(code) => console.log(1)} />
                    </div>
                </div>
                        {
                        erCaptch ?
                            <span class="flex items-center font-medium font-IRANYekanMedium mt-1 tracking-wide text-[#ff0000] text-xs  ml-1">
                                کپچا نادرست می باشد!
                            </span>
                            :
                            null
                    }
                <div className="flex items-center mt-[22px] mb-[8px]">
                    <input className="w-[15px] h-[15px] accent-mainColor2" type="checkbox" />
                    <label className="text-[10px] font-IRANYekanBold mr-[5px]">مرا به خاطر بسپار</label>
                </div>
                <div className="flex justify-center items-center">
                    <button
                        onClick={login}
                        className="w-full h-[40px] bg-mainColor2 hover:bg-nextColor shadow-norm-shadow rounded-[5px] flex justify-center items-center"
                    >
                        {snipper ? (
                            <ClipLoader
                                color={"#ffffff"}
                                loading={snipper}
                                size={30}
                                aria-label="Loading Spinner"
                                data-testid="loader"
                            />
                        ) : (
                            <p className="font-IRANYekanExtra text-[15px] text-white">ورود</p>
                        )}
                    </button>
                  
                </div>
                {isShown && (
                    <>
                        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="relative w-[30%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">
                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold text-red">
                                            درخواست نادرست !
                                        </span>
                                    </div>
                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm leading-relaxed">
نام کاربری یا رمز عبور نادرست می باشد.                                        </p>
                                    </div>
                                    <div className="flex items-center justify-end border-solid border-slate-200 rounded-b">
                                        <Link
                                            className="text-white mx-4 mb-2 rounded-md shadow-blueShadow bg-mainColor2 font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={handleClick}
                                        >
                                            فهمیدم
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Login;